<p>
  След успешна сделка обявата ви се маркира като <strong>„Завършила със сделка“</strong> и става невидима за останалите
  потребители. Видима остава само за вас и купувача.
</p>
<p>
  Ако разполагате с още бройки от същия артикул или искате да пъбликувате подобна обява със същата информация, не е
  необходимо да създавате нова от нулата. Може лесно да <strong>копирате обявата</strong> и да я активирате отново с
  нова крайна дата.
</p>
<h6 class="mt-3">Начини за копиране на обява:</h6>
<ul>
  <li>
    <strong>От страницата на обявата</strong> – отворете страницата на завършилата обява и натиснете бутона
    <strong>„Копиране като нова обява“</strong>.
  </li>
  <li>
    <strong>От профила ви:</strong> Навигирайте до <strong>„Профил“ → „Моите обяви“</strong>, намерете съответната обява
    и изберете <strong>„Копиране като нова обява“</strong> от бутона с <strong>три точки (⋮)</strong>.
  </li>
</ul>
<h6 class="mt-3">Какво се копира?</h6>
<p>
  При копиране се създава <strong>нова обява</strong> със същата информация – заглавие, описание, снимки, цена, условия
  и др. Единственото, което трябва да изберете, е <strong>нова крайна дата и час</strong>, до които новата обява ще бъде
  активна.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Копирането е удобно, когато имате повтаряеми артикули или искате бързо да активирате сходна
  оферта с минимални промени.
</div>
